import React from 'react';

import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';

import { CardTransportDetails } from 'handimap-react-lib/components/Card/CardTransportDetails';

export const SelectedTransportDetails = ({selectedTransport, status}) => {

  const styles = {
    container: {
      display: 'flex',
      width: '100%',
      alignItems: 'center'
    },
    card: {
      display: 'flex',
      width: '90%',
      paddingX: '.2em',
    },
    cardContent: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center'
    },
    stopText: {
      fontSize: '0.8em',
    }
  };

  return (
    <Stack sx={styles.container} direction='column' spacing={1.5}>
      {status === 'loading' && (
        <CircularProgress />
      )}
      { status !== 'loading' && selectedTransport !== undefined && 
        selectedTransport !== null && 
        Array.isArray(selectedTransport) &&
        selectedTransport.length > 0 && 
        selectedTransport.map(selected => {
          const {id} = selected;
          return (
            <CardTransportDetails key={id} featureTransport={selected} />
          );
        })
      }
      { status !== 'loading' && selectedTransport !== undefined && 
        selectedTransport !== null && 
        typeof selectedTransport === 'object' && (
        <CardTransportDetails featureTransport={selectedTransport} />
      )
       
      }
    </Stack>
  );
};